/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useReducer, useMemo } from 'react';
import RadioList from 'saur_ui_library/src/Molecules/RadioList/RadioList';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import DropDownList from 'saur_ui_library/src/Molecules/DropDownList/DropDownList';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import styled, { createGlobalStyle } from 'styled-components';
import Error from '../../components/common/ErrorMessage';
import { InputSwitch } from 'primereact/inputswitch';
import {
  HourArr,
  getBassin,
  onBassinChange,
  submit,
  handleEcpOnSubmit,
  getPoint,
  OnPointAvalChange,
  getPointAttached,
  OnPointAmontChange,
  OnPointDoChange,
  getParameters,
} from '../../utils/helpers/view/contractParameterHelper';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import SelectMulti from '../../components/common/SelectMulti';
import AutocompleteComponent from '../../components/common/component/AutocompleteComponent';
import { loaderDataComponent } from '../../utils/helper';

declare type EcpProps = {
  contractCode: string;
};

type formType = {
  id: null | any;
  collectionPoolId: null | any;
  collectionPoolType: null | any;
  hourPeakBegin: null | any;
  hourPeakEnd: null | any;
  nbConnected: null | any;
  consumption: null | any;
  ecpicoefType: null | any;
  ecpicoefValue: null | any;
  doSelected: null | any;
};

const CollectionPoolParameter = ({ contractCode }: EcpProps) => {
  // déclaration des variables
  const [doList, setDoList] = useState<any>([]);
  const [selectedDo, setSelectedDo] = useState<any>([]);
  const [paramList, setParamList] = useState<any>([]);
  const [pointAmont, setAmontPoint] = useState<any>([]);
  const [selectedPoints, setSelectedPoints] = useState<any>([]);
  const [selectedPointAmont, setSelectedPointAmont] = useState<any>([]);
  const [isDoAttached, setIsDoAttached] = useState(false);
  const [bassinData, setBassinData] = useState([]);
  const [pointAval, setAvalPoint] = useState<any>([]);
  const [selectedPointAval, setSelectedPointAval] = useState<any>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pointAmontError, setPointAmontError] = useState<any>('');
  const [pointAvalError, setPointAvalError] = useState<any>('');
  const [, setErrorMessage] = useState(
    "une erreur s'est produite. Veuillez réessayer"
  );
  const [, setTitle] = useState('');
  const contractId = window.sessionStorage.getItem('contractId')!;
  // stable reference — prevents selectedValue from changing identity on every render
  const arrayHour = useMemo(() => HourArr().map((c, index) => ({
    id: index,
    label: c.name,
    value: c.id,
    automatedTestId: 'dropdown-date' + index,
  })), []);
  //Form fields on initialization with getParam value
  const [form, setForm] = React.useState<formType>({
    id: paramList.id,
    collectionPoolId: paramList?.collectionPoolId,
    collectionPoolType: paramList.collectionPoolType,
    hourPeakBegin: paramList.hourPeakBegin,
    hourPeakEnd: paramList.hourPeakEnd,
    doSelected: paramList.doSelected,
    nbConnected: paramList?.nbConnected,
    consumption: paramList.consumption,
    ecpicoefType: paramList.ecpicoefType,
    ecpicoefValue: paramList.ecpicoefValue,
  });
  const hourBeginOption = useMemo(
    () => arrayHour.find(h => h.value === form.hourPeakBegin) ?? null,
    [form.hourPeakBegin, arrayHour]
  );
  const hourEndOption = useMemo(
    () => arrayHour.find(h => h.value === form.hourPeakEnd) ?? null,
    [form.hourPeakEnd, arrayHour]
  );
  //fonctions de validations
  //Form fields validation
  const [validation, setValidation] = React.useState<{
    collectionPoolId: null | any;
    hourPeakBegin: null | any;
    hourPeakEnd: null | any;
    ecpicoefValue: null | any;
    tresholds: null | any;
    tresholdMax: null | any;
  }>({
    collectionPoolId: null,
    hourPeakBegin: null,
    hourPeakEnd: null,
    // nbConnected: null,
    // consumption: null,
    ecpicoefValue: null,
    tresholds: null,
    tresholdMax: null,
  });
  const toast = useRef<any>(null);
  const [key, forceUpdate] = useReducer(x => x + 1, 0);

  const ShowToast = (severity: any, summary: any, detail: any) => {
    return toast.current?.show({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  };

  //Use effects
  useEffect(() => {
    getBassin(
      setLoading,
      setBassinData,
      contractCode,
      setError,
      setTitle,
      setErrorMessage
    );
  }, [contractCode]);

  useEffect(() => {
    if (form.collectionPoolId) {
      handleEcpOnSubmit(setValidation, form);
    }
  }, [form]);

  useEffect(() => {
    getPointAttached(
      contractId,
      'MDI_DO',
      setLoading,
      setDoList,
      selectedPoints,
      setError,
      setSelectedDo
    );
  }, [selectedPoints]);

  useEffect(() => {
    // force render to update label of AutocompleteComponent
    forceUpdate();
  }, [selectedPointAval]);

  useEffect(() => {
    setSelectedPointAmont(pointAmont.filter((c: any) => c.selectedPoint === true));
  }, [pointAmont]);

  return (
    <Container
      automatedTestId='ecp-global-container'
      className='ecp-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Container className='ecpContainer'>
        <Container className='ecpContent'>
          <Form
            onSubmit={() =>
              submit(
                form,
                validation,
                setLoading,
                ShowToast,
                pointAval,
                selectedPointAmont,
                selectedDo,
                setValidation
              )
            }
          >
            {/* Bassin de collecte */}
            <Container
              automatedTestId='ecp-bassin-select-container'
              className='bassin-container'
            >
              <Word
                variant='p'
                textStyle='normalReg'
                value='Bassin de collecte'
                className='bassin-title'
              />
              <AutocompleteComponent
                id='filtre-bassin'
                Listoption={bassinData.map((c: any) => {
                  return {
                    ...c,
                    name: c.label,
                  };
                })}
                onChangeValue={(event: any, bassin: any) => {
                  onBassinChange(
                    bassin,
                    setValidation,
                    (pointId: any) =>
                      getPoint(
                        contractId,
                        pointId,
                        setLoading,
                        setAmontPoint,
                        setAvalPoint,
                        setSelectedPointAval,
                        setSelectedPoints,
                        setPointAmontError,
                        setPointAvalError,
                        setError
                      ),
                    (parametersId: any) =>
                      getParameters(
                        parametersId,
                        setLoading,
                        setForm,
                        setParamList,
                        setIsDoAttached,
                        setError,
                        setTitle,
                        setErrorMessage
                      ),
                  );
                }}
              />
              <Container className='formLineError'>
                <Word
                  className='error'
                  textStyle='normalReg'
                  variant='span'
                  value={validation.collectionPoolId}
                />
              </Container>
            </Container>
            <Container
              automatedTestId='ecp-body-container'
              className='bodyContent'
            >
              <Container className='leftDataContent'>
                {/* Données générales */}
                <Card className='general-data'>
                  <Word
                    variant='p'
                    textStyle='title'
                    value='Données générales'
                    className='general-data-title'
                  />
                  {/* point limite aval */}
                  <Container className='aval-container'>
                    <Word
                      variant='span'
                      textStyle='normalReg'
                      value='Point limite aval'
                      className='limit-aval-title'
                    />
                    <AutocompleteComponent
                      id={'avalPoints'}
                      key={key}
                      Listoption={pointAval}
                      onChangeValue={(event: any, option: any) => {
                        OnPointAvalChange(
                          option,
                          pointAval,
                          setAvalPoint,
                          setSelectedPointAval
                        );
                      }}
                      defaultValue={{ name: selectedPointAval.length !== 0 ? selectedPointAval[0].name : 'Sélectionnez le point'}}
                    />
                    <Container className='formLineError'>
                      <Word
                        className='error'
                        textStyle='normalReg'
                        variant='span'
                        value={pointAvalError}
                      />
                    </Container>
                  </Container>
                  {/* Points limites amonts */}
                  <Container className='amonts-container'>
                    <Word
                      variant='span'
                      textStyle='normalReg'
                      value='Points limites amont'
                      className='limit-amonts-title'
                    />
                    <SelectMulti
                      id='multiSelect'
                      value={selectedPointAmont}
                      disabled={false}
                      options={pointAmont}
                      onChange={(options: any) =>
                        OnPointAmontChange(options, setSelectedPointAmont)
                      }
                      optionLabel='mainInstallName'
                      placeholder='Sélectionnez les points'
                    />
                  </Container>
                  <Container className='formLineError'>
                    <Word
                      className='error'
                      textStyle='normalReg'
                      variant='span'
                      value={pointAmontError}
                    />
                  </Container>
                  {/* type de bassin */}
                  <Container className='ecp-bassin-type'>
                    <Word
                      variant='span'
                      textStyle='normalReg'
                      value='Type de bassin'
                      className='bassin-type-title'
                    />
                    <RadioList
                      className='radiolist'
                      selected={
                        form.collectionPoolType ? form.collectionPoolType : 0
                      }
                      onChange={(v: any) => {
                        setForm((oldValues) => {
                          return { ...oldValues, collectionPoolType: v.id };
                        });
                      }}
                      values={[
                        {
                          id: 0,
                          label: 'Classique',
                          automatedTestId: 'collectionPool-classique',
                        },
                        {
                          id: 1,
                          label: 'Saisonnier',
                          automatedTestId: 'collectionPool-saisonnier',
                        },
                        {
                          id: 2,
                          label: 'Indus.',
                          automatedTestId: 'collectionPool-Indus',
                        },
                      ]}
                    />
                  </Container>
                  {/* heures creuses */}
                  <Container className='globale-date'>
                    <Word
                      variant='span'
                      textStyle='normalReg'
                      value='Heures creuses'
                      className='heures-creuses-title'
                    />
                    <Container className='global-date'>
                      <DropDownList
                        className='date'
                        values={arrayHour}
                        placeHolder='H.Début'
                        selectedValue={hourBeginOption}
                        onChange={(option) => {
                          setValidation((values) => ({
                            ...values,
                            hourPeakBegin:
                              option.value >= form.hourPeakEnd
                                ? 'La date de début est supérieure ou égale à la date de fin'
                                : null,
                          }));
                          setForm((oldValues) => {
                            return {
                              ...oldValues,
                              hourPeakBegin: option.value,
                            };
                          });
                        }}
                      />
                      <Word
                        variant='span'
                        textStyle='normalReg'
                        value='à'
                        className='conjonction'
                      />
                      <DropDownList
                        className='date'
                        values={arrayHour}
                        placeHolder='H.Fin'
                        selectedValue={hourEndOption}
                        onChange={(option) => {
                          setValidation((values) => ({
                            ...values,
                            hourPeakEnd:
                              option.value - form.hourPeakBegin > 20
                                ? 'La plage horaire doit être inférieure ou égale à 20 heures'
                                : null,
                          }));
                          setForm((oldValues) => {
                            return { ...oldValues, hourPeakEnd: option.value };
                          });
                        }}
                      />
                    </Container>
                    <Container className='formLineError'>
                      <Container className='formLineDateErrorItem'>
                        <Word
                          className='error'
                          textStyle='normalReg'
                          variant='span'
                          value={validation.hourPeakBegin}
                        />
                      </Container>
                      <Container className='formLineDateErrorItem'>
                        <Word
                          className='error'
                          textStyle='normalReg'
                          variant='span'
                          value={validation.hourPeakEnd}
                        />
                      </Container>
                    </Container>
                  </Container>
                </Card>
              </Container>
              <Container className='midDoContent'>
                {/* Prise en compte des déversements */}
                <Card className='check-do'>
                  <Word
                    variant='p'
                    textStyle='title'
                    value='Prise en compte des déversements'
                    className='do-data-title'
                  />
                  <InputSwitch
                    className='ecp-switch'
                    checked={isDoAttached}
                    onChange={(e: any) => {
                      setForm((oldValues) => {
                        return { ...oldValues, doSelected: e.value };
                      });
                      setIsDoAttached(e.value);
                    }}
                  />
                  <Word
                    variant='p'
                    textStyle='normalReg'
                    value='DO rattachés au bassin de collecte'
                    className='do-attached-title'
                  />
                  <SelectMulti
                    id='ecp-bassin-dropdown'
                    value={selectedDo}
                    disabled={false}
                    options={doList}
                    onChange={(options: any) =>
                      OnPointDoChange(
                        options,
                        setSelectedDo,
                      )
                    }
                    optionLabel='mainInstallName'
                    placeholder='Sélectionnez les points'
                  />
                </Card>
                <Card className='data-citizen'>
                  <Word
                    variant='p'
                    textStyle='title'
                    value='Données habitants'
                    className='people-data-title'
                  />
                  <Container className='citizen-number'>
                    <Word
                      variant='p'
                      textStyle='normalReg'
                      value="Nombre d'habitants raccordés"
                      className='number-title'
                    />
                    <InputNumber
                      className='seuil-input'
                      id='ecp-nb-habitant'
                      placeholder="Nombre d'habitants"
                      value={form?.nbConnected}
                      onValueChange={(v: any) => {
                        setForm((oldValues) => ({
                          ...oldValues,
                          nbConnected: v.value,
                        }));
                      }}
                    />
                  </Container>
                  <Container className='citizen-consumption'>
                    <Word
                      variant='p'
                      textStyle='normalReg'
                      value='Consommation évalué par habitant'
                      className='consumption-title'
                    />
                    <Container className='citizen-align'>
                      <InputNumber
                        id='ecp-conso-habitant'
                        className='consumption-input'
                        placeholder='Consommation'
                        value={form.consumption}
                        mode='decimal'
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        onValueChange={(v: any) => {
                          setForm((oldValues) => ({
                            ...oldValues,
                            consumption: v.value,
                          }));
                        }}
                      />

                      <Word
                        variant='p'
                        textStyle='normalReg'
                        value='m³/j'
                        className='consumption-unit'
                      />
                    </Container>
                  </Container>
                </Card>
              </Container>
              <Container className='rightDataContent'>
                <Card className='rightCoefContent'>
                  <Word
                    variant='p'
                    textStyle='title'
                    value='Coef de calcul ECPI'
                    className='coef-data-title'
                  />
                  <Word
                    variant='p'
                    textStyle='normalReg'
                    value='Valeur'
                    className='value-title'
                  />
                  <InputNumber
                    placeholder='Valeur'
                    id='ecp-valeur'
                    value={form.ecpicoefValue}
                    onValueChange={(v: any) => {
                      setValidation((values) => ({
                        ...values,
                        ecpicoefValue:
                          v.value < 0 || v.value > 100
                            ? 'Valeur obligatoire de type pourcentage comprise entre 0 et 100'
                            : null,
                      }));
                      setForm((oldValues) => ({
                        ...oldValues,
                        ecpicoefValue: v.value,
                      }));
                    }}
                  />
                  <Word
                    className='error'
                    textStyle='normalReg'
                    variant='span'
                    value={validation.ecpicoefValue}
                  />
                </Card>
              </Container>
            </Container>
            <Container className='ecpButton'>
            {loaderDataComponent(loading)}
            {loading === false && <StyledSectionButton>
              <Button className='ecp-btn' mode='plain'>
                <Word
                  variant='span'
                  textStyle='normalBold'
                  value='Enregistrer les modifications'
                />
              </Button>
            </StyledSectionButton>}
            </Container>
          </Form>
        </Container>
      </Container>
      {error ? <Error IsVisible={error}></Error> : null}
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  margin-top: 50px;
`;
const Styles = createGlobalStyle`

.ecp-global-container.sds-reset-style{
  .ecpContainer{  
    .error{
          color:red
        }
      .ecpContent{
        width:auto !important;
      }
      .bassin-container{
        //Validation error
        .error{
          color:red
        }
        .ecp-bassin-dropdown{
          .dropdown-icon-container{
            path{
              fill:#008BD2;
            }
          }
        }
    }

    // body
    .bodyContent{
      flex-direction: row;      
      .general-data, .check-do {
        overflow: visible;
        margin-top: 16px;
        margin-right:32px;
      }
      input.p-inputtext.p-component.p-inputnumber-input{
        background-color: #edf2fa;
        border: 1px solid #edf2fa;
        width: 249px;
        height: 55px;
        margin-top:0px;
        margin-bottom:20px;
        margin-right:20px;
        padding-left: 10px;
        font-size: 14px;
        font-style: italic;
        font-family: 'Montserrat';
        color: black;
      }
      .seuil-input{
        width: fit-content
      }
      //titre
      .general-data-title, .do-data-title, .people-data-title, .coef-data-title{
        text-align: center;
        margin-bottom: 15px;
      }
      // données générales
      .leftDataContent{ 

        .css-b62m3t-container{
          margin-bottom: 15px;
        }
        .css-1s2u09g-control {
          min-height: 55px;
          background-color: #EDF2FA;
        }

        .css-1pahdxg-control {
          min-height: 55px;
        }

        //Validation error
        .formLineError {
          flex-direction: column;
          margin-bottom: 30px;          
          .formLineDateErrorItem {
            align-items: flex-start;
            position: relative;
            width: 100%;
          }
        }
        .error{
          color:red
        }
        width: 35%;         
        .ecp-bassin-type{
          margin-bottom: 30px;
        }
        .general-data{
          path{
            fill: #008CD2;
          }
        }
        .global-date{
          flex-direction: row; 
          flex: 1;
          justify-content: space-between;
          .heures-invisible-title{
            color: #F5F8FB
          };
          .date{
            width:100%;
          }  
          .conjonction{
            align-self: center;
            text-align: center;
          }         
        }
        .global-date > * {
          flex: 1 0 auto;
        }
      }
      //prise en compte des déversements donnees habitants
      .midDoContent{
        width: 35%;  

        .check-do{
          .ecp-switch{
            align-self: center;
            margin-bottom: 10px;
          }
        } 
        
        .data-citizen{
          overflow: visible;
          margin-top: 16px;
          margin-right:32px; 

          .sds-word.tinyRegular.field-label{
            font-size:14px;
            color: #232323
          }
          sds-input{
            font-family: 'Montserrat';
          }
          .citizen-consumption{
            .citizen-align{
              flex-direction: row;      
              .consumption-unit{
                line-height: 4;
                margin-left:10px;
              }
            }
          }
        }
      }
      
      .rightDataContent{
        width: 35%;  

        // coef de calcul ECPI
        .rightCoefContent{
          overflow: visible;
          margin-top: 16px;
          margin-right:32px; 
          .FilterSelect{
            width:80%;
            align-self:center;
            margin-bottom: 15px;
            .filter-animate-content{
              background-color: #008BD2
            }      
          }
          .sds-word.tinyRegular.field-label{
            font-size:14px;
            color: #232323
          }  
        }   
        // tresholds
        .rightTresholdContent{
          overflow: visible;
          margin-top: 16px;
          margin-right:32px; 
          .FilterSelect{
            width:80%;
            align-self:center;
            margin-bottom: 15px;
            .filter-animate-content{
              background-color: #008BD2
            }            
          }
          .sds-word.tinyRegular.field-label{
            font-size:14px;
            color: #232323
          }   
        }
      }
    }
    .ecpButton{
      align-items: center;
      margin-top: 15px;
    }
  }
  .radiolist{
    flex-direction: row;
    justify-content: space-around;

  .radio-item{
    margin-bottom:auto;
    margin-right: 0.5vw
  }
  }
  .p-inputswitch{
    width: 48px;
    height: 28px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
  .p-multiselect-label-container{
    overflow-y: scroll;
  }
}
`;

export default CollectionPoolParameter;
